import { createContext, useContext } from 'react';

export const SelectOptionsContext = createContext<{
  mode: 'gift' | 'purchase';
}>({
  mode: 'purchase',
});

export const useSelectOptionContext = () => {
  const context = useContext(SelectOptionsContext);
  return context;
};
